import React, { useState, useEffect, useContext } from "react";
import MobilePageLayout from "../components/MobilePageLayout";
import HomeButton from "../components/HomeButton";
import SaapApi from "../sdk/SaapApi";
import HttpService from "../sdk/HttpAxios";
import Logger from "../sdk/Logger";
import NavigationContext from "../components/NavigationContext";

const UnlockPage = ({ selectedOrder }) => {
  const [status, setStatus] = useState("Initializing...");
  const [unlocking, setUnlocking] = useState(false);

  const [supportsBluetooth, setSupportsBluetooth] = useState(false);

  const [terminal, setTerminal] = useState("");
  const [sdkId, setSdkId] = useState(null);
  const [api, setApi] = useState(null);

  const { setDisableHome } = useContext(NavigationContext);

  /* ✅ Bluetooth + SDK init */
  useEffect(() => {
    setSupportsBluetooth(!!navigator.bluetooth);

    (async () => {
      try {
        const apiInstance = SaapApi.getInstance();
        const resp = await apiInstance.init("saap-esore-web");
        setSdkId(resp.sdkId);

        apiInstance.setListener({
          onNotification: (code, data, btAddr, plainJson) => {
            Logger.log("SDK NOTIFICATION:", code, data, btAddr, plainJson);

            if (code === SaapApi.NOTIF_LOCK_UNLOCKED) {
              Logger.info("Door Unlocked:", data, btAddr);
              setStatus(
                "<b>Door is Unlocked</b>.<br>Please close the door firmly after retrieving your items.",
              );
              setTimeout(() => {
                window.location.href = "/";
              }, 20000);
            } else if (code === SaapApi.NOTIF_SRV_REPORT) {
              Logger.info(
                "Server Report:",
                data,
                btAddr,
                selectedOrder.secret,
                plainJson,
              );

              if (plainJson) {
                try {
                  const reportData = JSON.parse(plainJson);
                  if (
                    reportData &&
                    reportData.log &&
                    reportData.log.length > 0
                  ) {
                    const code = reportData.log[0].code;
                    if (code === "BkngIdVrfFail") {
                      setStatus(
                        "<b>The Order is no more valid</b>.<br>Please contact support.",
                      );
                    } else {
                      Logger.error(
                        "SDK NOTIFICATION:",
                        code,
                        data,
                        btAddr,
                        plainJson,
                      );
                      // setStatus(
                      //   "<b>Something Wrong!</b><br>Please Contact Support.",
                      // );
                    }
                  }
                } catch (e) {
                  // console.log("Failed to parse report data", e);
                }
              }

              // Send log to server
              const http = new HttpService();
              http.sendLog({
                data,
                btAddr,
                secret: selectedOrder.secret,
              });
            } else if (code.includes("ERROR") || code.includes("FAILED")) {
              Logger.error("SDK ERROR:", code, data, btAddr, plainJson);
              setStatus("<b>Something Wrong!</b><br>Please Contact Support.");
              setTimeout(() => {
                window.location.href = "/";
              }, 10000);
            }
          },
        });

        setApi(apiInstance);
      } catch (err) {
        console.error(err);
        setStatus("Failed to initialize SDK");
      }
    })();
  }, []);

  /* ✅ Auto-unlock when ready */
  useEffect(() => {
    if (supportsBluetooth && api && sdkId && selectedOrder && !unlocking) {
      unlockWithOrder();
    }
  }, [supportsBluetooth, api, sdkId, selectedOrder]);

  const validate = () => {
    if (!supportsBluetooth) {
      setStatus("Bluetooth not supported on this device.");
      return false;
    }
    if (!api || !sdkId) {
      setStatus("Not ready.");
      return false;
    }
    if (!selectedOrder) {
      setStatus("No order selected.");
      return false;
    }
    return true;
  };

  const renderStatus = () => {
    if (!status) return null;
    const containsHtml = /<[^>]+>/.test(status);
    return containsHtml ? (
      <p className="status" dangerouslySetInnerHTML={{ __html: status }} />
    ) : (
      <p className="status">{status}</p>
    );
  };

  const unlockWithOrder = async () => {
    if (!validate()) return;

    // Request token for my order
    let order;
    const http = new HttpService();

    try {
      // console.log("SelectedOrder:", selectedOrder);

      setStatus("Please wait while processing order...");
      order = await http.requestTokenByOrder(sdkId, selectedOrder);
    } catch (error) {
      if (error.status === 404) {
        setStatus("Something went wrong. Please contact support.");
      }
      setUnlocking(false);
      return;
    }

    if (!order || !order.token) {
      setStatus("Something went wrong. Please contact support.");
      return;
    }

    // Execute unlock command with the token
    // console.log("Token", order.token);

    setStatus("Connecting...");
    setUnlocking(true);
    setDisableHome(true);

    try {
      // console.log("Sending token...", order.token);
      await api.executeToken(order.token, SaapApi.LOCKER_ACTION_UNLOCK);
      // console.log("Command Executed...");
    } catch (err) {
      // console.log(`Unlock failed: ${err.message}`);
      setStatus(`Unlock failed. Pease retry.`);
      setUnlocking(false);
    } finally {
      setDisableHome(false);
    }
  };

  // ✅ If Bluetooth is not supported, render only the message
  if (!supportsBluetooth) {
    return (
      <MobilePageLayout>
        <img src="/locker.png" className="locker" alt="SAFECLOAK" />
        <div style={{ textAlign: "center" }}>
          <h2 className="page-title">SmartStore</h2>
          <p>
            Sorry! Unlocking is not supported from this device.
            <br />
            Please contact support
          </p>
        </div>
      </MobilePageLayout>
    );
  }

  return (
    <MobilePageLayout>
      <HomeButton />
      <img src="/logo.png" className="logo" alt="LOKRAM" />

      <h2 className="page-title">Unlock</h2>

      {selectedOrder && (
        <div className="order-details">
          <p>
            <strong>Box:</strong> {selectedOrder.boxName}
          </p>
        </div>
      )}

      {renderStatus()}
    </MobilePageLayout>
  );
};

export default UnlockPage;
